import React from 'react'

const TeamCompareHeader = ({
  bordered  = false,
  noTeams   = false,
  home      = {},
  away      = {},
  heading   = ''
}) => {
  const classNames = [ 'teamCompareHeaderWrap', (noTeams ? 'no-teams' : ''), (bordered ? 'bordered' : '') ]
  return (
    <div className={classNames.join(' ')}>
      <div className="teamCompareHeader">
      <div className="team team1">
        <img className="imageLoaded" src={home.logo}/>
        <span className="record">{home.name}</span>
      </div>
      <div className="header">{heading}</div>
      <div className="team team2">
        <span className="record">{away.name}</span>
        <img className="imageLoaded" src={away.logo}/>
      </div>
      </div>
    </div>
  )
}

export default TeamCompareHeader



/** WEBPACK FOOTER **
 ** ../app/components/gamepackage/rugby/components/statistics/TeamCompareHeader.jsx
 **/